import { render, staticRenderFns } from "./UkrTreasuresFilter.vue?vue&type=template&id=c04cf548&scoped=true"
import script from "./UkrTreasuresFilter.vue?vue&type=script&lang=js"
export * from "./UkrTreasuresFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c04cf548",
  null
  
)

export default component.exports